import React from 'react';
import { useTheme } from '../../ThemeContext';
import { ModalShell, Button } from '../ui';


export default function AddLinkModal({ 
  show, 
  onClose, 
  newLinkType,
  setNewLinkType,
  newLinkUrl,
  setNewLinkUrl,
  onAddLink
}) {
  const { t, isDark } = useTheme();
  if (!show) return null;

  return (
    <ModalShell onClose={onClose} maxWidth="400px" panelStyle={{ backgroundColor: t.modalBg, borderRadius: '16px' }}>
        <h2 style={{ 
          fontFamily: 'Crimson Pro, serif', 
          fontSize: '28px', 
          marginBottom: '8px',
          color: t.text
        }}>
          Add Social Link
        </h2>
        <p style={{ 
          color: t.textSecondary, 
          marginBottom: '24px',
          fontSize: '14px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Add a link to your social profile
        </p>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ fontSize: '13px', fontWeight: '600', color: t.text, display: 'block', marginBottom: '6px' }}>
            Platform *
          </label>
          <select
            value={newLinkType}
            onChange={(e) => setNewLinkType(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              outline: 'none',
              backgroundColor: t.surface
            }}
          >
            <option value="X">X / Twitter</option>
            <option value="LinkedIn">LinkedIn</option>
            <option value="GitHub">GitHub</option>
            <option value="Website">Website</option>
            <option value="Medium">Medium</option>
            <option value="Substack">Substack</option>
            <option value="Instagram">Instagram</option>
            <option value="YouTube">YouTube</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ fontSize: '13px', fontWeight: '600', color: t.text, display: 'block', marginBottom: '6px' }}>
            URL *
          </label>
          <input
            type="url"
            value={newLinkUrl}
            onChange={(e) => setNewLinkUrl(e.target.value)}
            placeholder="https://..."
            style={{
              width: '100%',
              padding: '12px',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = t.accent}
            onBlur={(e) => e.target.style.borderColor = t.borderStrong}
          />
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <Button onClick={onAddLink} disabled={!newLinkUrl.trim()} style={{ flex: 1 }}>
            Add Link
          </Button>
          <Button variant="secondary" onClick={onClose} style={{ flex: 1 }}>
            Cancel
          </Button>
        </div>
    </ModalShell>
  );
}
